<template>
  <v-container
    fluid
    grid-list-md
  >
    <h1 class="text-h5">{{ $t('Settings') }}</h1>
    <v-row>
      <v-col lg="4">
        <v-form @submit.prevent="saveSettings">
          <v-card class="pa-4 text-center">
            <v-card-text>
              <v-text-field
                v-if="cashRegister"
                v-model="cashRegister.description"
                :label="$t('Cash Register')"
                autocomplete="off"
                filled
                readonly
              />
              <v-text-field
                v-if="cashRegister.store"
                v-model="cashRegister.store.name"
                :label="$t('Store')"
                autocomplete="off"
                filled
                readonly
              />
              <v-text-field
                v-if="cashRegister"
                v-model="cashRegister.identifier"
                :label="$t('Cash Register Code')"
                autocomplete="off"
                filled
                readonly
              />
              <v-text-field
                v-if="cashRegister"
                :label="$t('Installation Date')"
                :value="cashRegister.installationDate | moment('D MMMM YYYY HH:mm')"
                autocomplete="off"
                filled
                readonly
              />
              <v-select
                v-if="localPrinters"
                v-model="printer"
                :disabled="!isQzTrayInstalled"
                :items="localPrinters"
                :label="$t('Printer')"
                :loading="$wait.is('fetching printerlist')"
                clearable
                dense
                filled
                item-text="label"
                item-value="key"
              >
                <template v-slot:append-outer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        @click="updateLocalPrinterList()"
                      >sync</v-icon>
                    </template>
                    <span>{{ $t('Reload {0}', [$t('Printerlist')]) }}</span>
                  </v-tooltip>
                </template>
              </v-select>
              <p
                v-if="!isQzTrayInstalled"
                class="text-left red--text"
              >
                <v-btn
                  :href="`${baseUrl}/qz-tray.exe`"
                  class="white--text ma-0"
                  color="primary"
                >
                  {{ $t('Download') }} QZ-Tray
                  <v-icon
                    dark
                    small
                    right
                  >
                    fal fa-download
                  </v-icon>
                </v-btn>
              </p>

              <v-divider />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                v-show="isQzTrayInstalled"
                :loading="$wait.is('saving settings')"
                class="font-weight-bold"
                color="primary"
                text
                @click="saveSettings"
              >{{ $t('Save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import qz from '@/../own_modules/qz-tray/qz-tray'

export default {
  metaInfo () {
    return { title: this.pageTitle }
  },

  data: () => ({
    interval: null,
    localPrinters: [],
    pageTitle: Vue.i18n.translate('Settings')
  }),

  computed: {
    ...mapGetters(['cashRegister', 'isCashRegisterConfigured', 'baseUrl']),
    ...mapState(['isQzTrayInstalled']),
    printer: {
      get () {
        return this.$store.state.printer
      },
      set (newPrinter) {
        this.$store.dispatch('SET_PRINTER', newPrinter)
      }
    }
  },

  created () {
    const isQZTrayActive = this.checkQZTrayInstalled()
    if (!isQZTrayActive) {
      const self = this
      this.interval = setInterval(function () {
        let value = self.checkQZTrayInstalled()
        if (value) {
          clearInterval(self.interval)
        }
      }, 3000)
    }
  },

  methods: {
    getLocalPrinterList () {
      this.$wait.start('fetching printerlist')
      return qz.printers.find()
        .then((data) => {
          // sort list of printers alphabetically
          // return object instead of string => value of select item should be same as label
          this.localPrinters = [{ key: '', label: this.$t('No {0}', [this.$t('Printer').toLowerCase()]) }]
          this.localPrinters = _.concat(this.localPrinters, data.sort().map(printer => {
            return {
              'key': printer,
              'label': printer
            }
          }))
          console.log(this.localPrinters)
        })
        .catch((data) => this.helpers.toastError(data.toString()))
        .finally(() => this.$wait.end('fetching printerlist'))
    },
    updateLocalPrinterList () {
      this.getLocalPrinterList()
        .then(() => this.helpers.toastSuccess(this.$t('{0} has been loaded.', [this.$t('Printerlist')])))
    },
    saveSettings () {
      if (this.printer === null) {
        this.$toast.error(this.$t('Select a {0}', [this.$t('Printer').toLowerCase()]))
      } else {
        this.$wait.start('saving settings')
        this.$store.dispatch('SET_PRINTER', this.printer)
          .then(() => {
            this.helpers.toastSuccess(this.$t('{0} have been saved', [this.$t('Settings')]))
            this.$router.push({ name: 'Cart' })
          })
          .finally(() => this.$wait.end('saving settings'))
      }
    },
    checkQZTrayInstalled () {
      const isQZTrayActive = qz.websocket.isActive()
      if (isQZTrayActive) {
        this.$store.commit('SET_QZTRAY_INSTALLED', true)
        this.getLocalPrinterList()
      }
      return isQZTrayActive
    }
  },

  beforeRouteLeave (to, from, next) {
    // Prevent navigating away when the cash register has not been configured
    if (!this.isCashRegisterConfigured) {
      this.helpers.toastError(this.$t('Before continuing, you need to configure the cash register.'))
      return next(false)
    }
    next()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cash-registers/Settings.vue